import React from 'react';

const steps = [
  {
    no: '01',
    title: 'Scope call',
    body: 'A free 30-minute conversation about what you need. No pitch deck, no pressure — we tell you honestly if you don’t need us.',
  },
  {
    no: '02',
    title: 'Fixed quote, in writing',
    body: 'You get an exact figure before anyone starts building. The number in your proposal is the number on your invoice.',
  },
  {
    no: '03',
    title: 'Build, in the open',
    body: 'You see working software every week, not a big reveal at the end. Two rounds of revisions are included at every stage.',
  },
  {
    no: '04',
    title: 'Launch and care',
    body: 'Every project includes 30 days of free fixes. After that, a monthly care plan or pay-as-you-go — and you own everything either way.',
  },
];

export const Process = () => (
  <div className="wrap">
    <section id="process">
      <div className="sec-head">
        <h2>How we work</h2>
        <span className="sec-tag">No hourly surprises</span>
      </div>
      <p className="sec-sub">
        The process is deliberately boring: agree on the thing, agree on the
        price, build the thing.
      </p>
      <div className="steps">
        {steps.map((s) => (
          <div className="step" key={s.no}>
            <span className="no">{s.no}</span>
            <h3>{s.title}</h3>
            <p>{s.body}</p>
          </div>
        ))}
      </div>
    </section>
  </div>
);
